import React, { useState } from "react";
import ProjectsCard from "./ProjectsCard";
import { Link } from "react-router-dom";
import "./Projects.css";
import allprojectsdata from "../data/projectsdata";

const Projects = ({ more }) => {
	// eslint-disable-next-line no-unused-vars
	const [projects, setProjects] = useState(allprojectsdata);

	const mainprojects = projects.slice(0, 3);

	return (
		<div className="pb-5 bg-dark text-white">
			<h3 className="text-center mb-5">Some of my works</h3>

			{more !== true && (
				<Link to="/projects">
					<h4 className="text-decoration-none text-white text-right mx-3">
            See more
					</h4>
				</Link>
			)}
			{more ? (
				<div className=" row">
					{projects.map((projectdata) => (
						<ProjectsCard projectdata={projectdata} key={projectdata.livelink} />
					))}
				</div>
			) : (
				<div className=" row">
					{mainprojects.map((projectdata) => (
						<ProjectsCard projectdata={projectdata} key={projectdata.livelink} />
					))}
				</div>
			)}
		</div>
	);
};

export default Projects;
